module.exports = __webpack_public_path__ + "img/star.a2889ed1.png";